import { TENANT_COM } from 'shared/consts/tenants'
import { isErxAdyenMpActive } from 'shared/experiments/utils/erxAdyen'
import store from 'shared/store'
import buildClientAPI from 'views/providers/clientAPI'

export default () => {
  const { cartService } = buildClientAPI()

  const DATA_HOOKS = {
    conventionalPrescription: 'conventional-prescription',
    ePrescription: 'e-prescription',
    ePrescriptionInfo: 'e-prescription-info',
    prescriptionInfo: 'prescription-info',
    conventionalPrescriptionInfo: 'conventional-prescription-info',
    miraklInfo: 'mirakl-info',
    differenceLink: 'difference-link',
  }

  const renderModal = ({ hasERxItems, hasRxItems, hasMiraklItems }) => {
    function getClientSideHook(name) {
      return document.querySelector(`[data-clientside-hook="${name}"]`)
    }

    const {
      pageProperties: { experiments },
    } = store.getPublicRuntimeConfig()
    const hasMiraklItemsandErxAdyenExpDisabled =
      hasMiraklItems && !isErxAdyenMpActive(experiments)
    const rxButton = getClientSideHook(DATA_HOOKS.conventionalPrescription)
    const eRxButton = getClientSideHook(DATA_HOOKS.ePrescription)
    const info = getClientSideHook(DATA_HOOKS.prescriptionInfo)

    if (hasMiraklItemsandErxAdyenExpDisabled || hasRxItems) {
      eRxButton.classList.add('a-Button--disabled')
      eRxButton.addEventListener('click', event => event.preventDefault())

      info.classList.remove('u-hidden')

      hasMiraklItemsandErxAdyenExpDisabled
        ? getClientSideHook(DATA_HOOKS.miraklInfo).classList.remove('u-hidden')
        : getClientSideHook(
            DATA_HOOKS.conventionalPrescriptionInfo
          ).classList.remove('u-hidden')
    }

    if (hasERxItems) {
      rxButton.classList.add('a-Button--disabled')
      rxButton.addEventListener('click', event => event.preventDefault())

      info.classList.remove('u-hidden')

      document
        .querySelector(
          `[data-clientside-hook="${DATA_HOOKS.ePrescriptionInfo}"]`
        )
        .classList.remove('u-hidden')
    }

    getClientSideHook(DATA_HOOKS.differenceLink)?.addEventListener(
      'click',
      event => event.preventDefault()
    )
  }

  const {
    publicConfig: { tenant },
  } = store.getPublicRuntimeConfig()

  if (tenant !== TENANT_COM) {
    return
  }

  cartService.fetchMetadata().then(response => renderModal(response.data))
}
